<div class="unauthorized-container">
  <div class="card">
    <div class="icon">
      <span class="material-icons error-icon">lock</span>
    </div>
    <h1>Unauthorized Access</h1>
    <p>You do not have permission to the platform.<br>
       Please login with appropriate access.</p>

    <div class="actions">
      <button mat-raised-button color="primary" routerLink="/login">
        <span class="material-icons">login</span>&nbsp; Go to Login
      </button>
    </div>
  </div>
</div>

